import gql from 'graphql-tag';

export const SEARCH_CONTRIBUTIONS = gql`
  query searchContributions($idValue: ID!) {
    SearchContributions(id:$idValue) {
      id
    }
  }
`;

export const CREATE_CONTRIBUTION = gql`
  mutation createContribution(
    $id: ID,
    $role: String,
    $instrumentType: String,
    $equipmentType: String,
    $featured: Boolean,
    $contracted: Boolean,
    $isCredited: Boolean,
    $creditText: String,
    $value: Float,
    $unit: String,
    $title: String,
    $description: String,
    $status: String,
    $dueDate: _Neo4jDateTimeInput,
    $taskGroup: String
  ) {
  CreateContribution(
    id: $id,
    role: $role,
    instrumentType: $instrumentType,
    equipmentType: $equipmentType,
    featured: $featured,
    contracted: $contracted,
    isCredited: $isCredited,
    creditText: $creditText,
    value: $value,
    unit: $unit,
    title: $title,
    description: $description,
    status: $status,
    dueDate: $dueDate,
    taskGroup: $taskGroup
  ) {
    id,
    role,
    instrumentType,
    equipmentType,
    featured,
    contracted,
    isCredited,
    creditText,
    value,
    unit,
    title,
    description,
    status,
    dueDate { formatted },
    taskGroup
  }
}
`;

export const CREATE_CONTRIBUTION_WITH_PROJECT_CONTRIBUTION = gql`
  mutation createContributionWithProjectContributions(
    $personId: ID!,
    $projectId: ID!,
    $input: ContributionInput,
  ) {
  CreateContributionWithProjectContributions(
    personId: $personId,
    projectId: $projectId,
    input: $input,
  ) {
    id,
    role,
    instrumentType,
    equipmentType,
    featured,
    contracted,
    isCredited,
    creditText,
    value,
    unit,
    title,
    description,
    status,
    dueDate { formatted },
    taskGroup,
    createdBy {
      id,
      fullName
    }
    creationDate  { formatted },
    lastModifiedDate { formatted }
  }
}
`;

export const UPDATE_CONTRIBUTION = gql`
  mutation updateContribution(
    $personId: ID!,
    $projectId: ID!,
    $input: ContributionInput
  ) {
    UpdateContribution(
      personId: $personId,
      projectId: $projectId,
      input: $input
  ) {
    id,
    role,
    instrumentType,
    equipmentType,
    featured,
    contracted,
    isCredited,
    creditText,
    value,
    unit,
    title,
    description,
    status,
    dueDate { formatted },
    taskGroup,
    createdBy {
      id,
      fullName
    }
    creationDate  { formatted },
    lastModifiedDate { formatted }
  }
}
`;

export const DELETE_CONTRIBUTION = gql`
  mutation deleteContribution (
    $personId: ID!,
    $projectId: ID!,
    $contributionId: ID!
  ) {
  DeleteContribution(
    personId: $personId,
    projectId: $projectId,
    contributionId: $contributionId
  ) {
    id
  }
}
`;

export const RESET_CONTRIBUTION_TAGS = gql`
  mutation resetTagsToContribution(
    $contributionId: ID!
    $tagNames: [String]!
  ) {
    ResetTagsToContribution(
      contributionId: $contributionId
      tagNames: $tagNames
    ) {
      id,
      name
    }
  }
`;

export const ADD_CONTRIBUTION_TAGS = gql`
  mutation AddContributionTags(
  $from: _TagInput!
  $to: _ContributionInput!
  ){
  AddContributionTags(
    from: $from
    to: $to
  ) {
    from { id }
    to { id }
    }
  }
`;

export const REMOVE_CONTRIBUTION_TAGS = gql`
  mutation RemoveContributionTags(
  $from: _TagInput!
  $to: _ContributionInput!
  ){
  RemoveContributionTags(
    from: $from
    to: $to
  ) {
    from { id }
    to { id }
    }
  }
`;

export const RESET_CONTRIBUTION_CONTRIBUTORS = gql`
  mutation addOrRemoveMultipleContributorsToContribution (
    $contributionId: ID!
    $personIds: [String]!
  ) {
    AddOrRemoveMultipleContributorsToContribution(
      contributionId: $contributionId
      personIds: $personIds
  ) {
      id,
   	  fullName
    }
  }
  `;

export const ADD_CONTRIBUTION_CONTRIBUTOR = gql`
 mutation addContributionContributor (
    $partyId: ID!
    $contributionId: ID!
  ) {
    AddContributionContributor(
    partyId: $partyId
    contributionId: $contributionId
  ) {
      id, title, description
    }
  }
`;

export const REMOVE_CONTRIBUTION_CONTRIBUTOR = gql`
  mutation removeContributionContributor (
    $partyId: ID!
    $contributionId: ID!
  ) {
    RemoveContributionContributor(
    partyId: $partyId
    contributionId: $contributionId
  ) {
    id
    }
  }
`;

export const UPDATE_TASK_GROUP = gql`
  mutation updateTaskGroup (
    $personId: ID!,
    $projectId: ID!,
    $taskIds: [String]!,
    $groupName: String
  ) {
    UpdateTaskGroup(
      personId: $personId,
      projectId: $projectId,
      taskIds: $taskIds,
      groupName: $groupName
    ) {
      id,
      title,
      description,
      taskGroup
    }
  }
`;

export const GET_TASKS_OF_PROJECT = gql`
  query getTasksOfProject (
    $personId: ID!,
    $projectId: ID!,
  ) {
    Project(
    personId: $personId,
    projectId: $projectId,
    ) {
      tasks: contributions {
      id,
      title,
      description,
      status,
      dueDate { formatted },
      contributor {
        ...on Person {
        id,
        fullName,
        accountId,
        authStatus,
        imageDepictions {
        id,
        title,
        type,
        thumbnail { 
          id, 
          file { 
            uri 
            }
          }
      }
      }
        id,
        fullName,
        imageDepictions {
        id,
        title,
        type,
        thumbnail { 
          id, 
          file { 
            uri 
            }
          }
      }
        __typename
      }
      role,
      tags {
        id,
        name
      }
      taskGroup,
      createdBy {
        id,
        fullName
      }
      creationDate  { formatted },
      lastModifiedDate { formatted }
      comments {
          id,
          text,
          creationDate {
            formatted
          }
          lastModifiedDate { formatted },
          author {
            id,
            fullName,
            accountId,
            authStatus,
            imageDepictions {
            id,
            thumbnail { 
              id, 
              file { 
                uri 
                }
              }
            }
            __typename
          }
        }
      }
    }
  }
`;

export const GET_TASKS_OF_MULTIPLE_PROJECT = gql`
  query allProjectsTasks (
    $personId: ID!,
    $projectIds: [ID]!,
  ) {
    AllProjectsTasks(
    personId: $personId,
    projectIds: $projectIds,
    ) {
      id,
      title,
      description,
      status,
      dueDate { formatted },
      taskGroup,
      contributedTo {
        id
      }
    }
  }
`;



export const ADD_SOURCE_FILE_COMPONENT_CONTRIBUTION = gql`
 mutation addSourceFileComponentContributor (
    $personId: ID!
    $projectId: ID!
    $componentId: ID!
    $otherPersonId: ID!
    $role: String!
  ) {
    AddSourceFileComponentContributor(
      personId: $personId
      projectId: $projectId
      sourceFileId: $componentId
      otherPersonId: $otherPersonId
      role: $role
  ) {
      id
    }
  }
`;

export const UPDATE_RECORDING_COMPONENT_CONTRIBUTION_ROLE = gql`
 mutation updateRecordingComponentContributionRole (
    $personId: ID!
    $projectId: ID!
    $componentId: ID!
    $contributionId: ID!
    $role: String!
  ) {
    UpdateRecordingComponentContributionRole(
      personId: $personId
      projectId: $projectId
      recordingId: $componentId
      contributionId: $contributionId
      role: $role
  ) {
      id
    }
  }
`;

export const UPDATE_SOURCE_FILE_COMPONENT_CONTRIBUTION_ROLE = gql`
 mutation updateSourceFileComponentContributionRole (
    $personId: ID!
    $projectId: ID!
    $componentId: ID!
    $contributionId: ID!
    $role: String!
  ) {
    UpdateSourceFileComponentContributionRole(
      personId: $personId
      projectId: $projectId
      sourceFileId: $componentId
      contributionId: $contributionId
      role: $role
  ) {
      id
    }
  }
`;

export const DELETE_RECORDING_COMPONENT_CONTRIBUTION = gql`
 mutation deleteRecordingComponentContribution (
    $personId: ID!
    $projectId: ID!
    $componentId: ID!
    $contributionId: ID!
  ) {
    DeleteRecordingComponentContribution(
      personId: $personId
      projectId: $projectId
      recordingId: $componentId
      contributionId: $contributionId
  ) {
      id
    }
  }
`;

export const DELETE_SOURCE_FILE_COMPONENT_CONTRIBUTION = gql`
 mutation deleteRecordingComponentContribution (
    $personId: ID!
    $projectId: ID!
    $componentId: ID!
    $contributionId: ID!
  ) {
    DeleteSourceFileComponentContribution(
      personId: $personId
      projectId: $projectId
      sourceFileId: $componentId
      contributionId: $contributionId
  ) {
      id
    }
  }
`;

export const DELETE_WORK_CONTRIBUTION_TO_RECORDING = gql`
 mutation archiveWorkContributionContributor_RECORDING(
   $personId: ID!
   $projectId: ID!
   $componentId: ID!
   $contributionId: ID!
  ) {
    ArchiveWorkContributionContributor_RECORDING(
      personId: $personId
      projectId: $projectId
      recordingId: $componentId
      contributionId: $contributionId
  ) {
      id
    }
  }
`;

export const UPDATE_CONTRUIBUTION_ON_WORK_RECORDING = gql`
  mutation updateWorkContributionContributorRole_RECORDING(
    $personId: ID!
    $projectId: ID!
    $componentId: ID!
    $contributionId: ID!
    $role: String!
  ) {
    UpdateWorkContributionContributorRole_RECORDING(
      personId: $personId
      projectId: $projectId
      recordingId: $componentId
      contributionId: $contributionId
      role: $role
    ) {
      id
      role
    }
  }
`;

export const ADD_COMPONENT_CONTRIBUTION = gql`
 mutation AddComponentContributor (
    $personId: ID!
    $projectId: ID!
    $label: String!
    $componentId: ID!
    $otherPersonId: ID!
    $role: String!
  ) {
    AddComponentContributor(
      personId: $personId
      projectId: $projectId
      label: $label
      componentId: $componentId
      otherPersonId: $otherPersonId
      role: $role
  ) {
      id
    }
  }
`;

export const UPDATE_COMPONENT_CONTRIBUTION_ROLE = gql`
 mutation UpdateComponentContributionRole (
    $personId: ID!
    $projectId: ID!
    $label: String!
    $componentId: ID!
    $contributionId: ID!
    $role: String!
  ) {
    UpdateComponentContributionRole(
      personId: $personId
      projectId: $projectId
      label: $label
      componentId: $componentId
      contributionId: $contributionId
      role: $role
  ) {
      id
    }
  }
`;

export const DELETE_COMPONENT_CONTRIBUTION = gql`
 mutation DeleteComponentContribution (
    $personId: ID!
    $projectId: ID!
    $label: String!
    $componentId: ID!
    $contributionId: ID!
  ) {
    DeleteComponentContribution(
      personId: $personId
      projectId: $projectId
      label: $label
      componentId: $componentId
      contributionId: $contributionId
  ) {
      id
    }
  }
`;

export const ADD_WORK_CONTRIBUTION = gql`
 mutation addWorkContributionContributor (
    $personId: ID!
    $projectId: ID!
    $label: String!
    $componentId: ID!
    $otherPersonId: ID!
    $role: String!
  ) {
    AddWorkContributionContributor(
      personId: $personId
      projectId: $projectId
      label: $label
      componentId: $componentId
      contributorId: $otherPersonId,
      role: $role)
  }
`

export const UPDATE_WORK_CONTRIBUTION = gql`
  mutation updateWorkContributionContributorRole_RECORDING(
    $personId: ID!
    $projectId: ID!
    $label: String!
    $componentId: ID!
    $contributionId: ID!
    $role: String!
  ) {
    UpdateWorkContributionContributorRole_RECORDING(
      personId: $personId
      projectId: $projectId
      label: $label
      componentId: $componentId
      contributionId: $contributionId
      role: $role
    ) {
      id
      role
    }
  }
`;

export const DELETE_WORK_CONTRIBUTION = gql`
 mutation archiveWorkContributionContributor(
   $personId: ID!
   $projectId: ID!
   $label: String!
   $componentId: ID!
   $contributionId: ID!
  ) {
    ArchiveWorkContributionContributor(
      personId: $personId
      projectId: $projectId
      label: $label
      componentId: $componentId
      contributionId: $contributionId
  ) {
      id
    }
  }
`;